import { render, staticRenderFns } from "./StorageInput.vue?vue&type=template&id=76caf731&"
import script from "./StorageInput.vue?vue&type=script&lang=ts&"
export * from "./StorageInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports